import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getCheckoutUrl, getTotalPrice, getBumps, setPopupOpen, subscribe } from '../utils/checkoutStore';
import { trackAddToCart } from '../utils/metaPixel';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [checkoutUrl, setCheckoutUrl] = useState(getCheckoutUrl());
  const [totalPrice, setTotalPrice] = useState(getTotalPrice());
  useEffect(() => {
    const unsubscribe = subscribe(() => {
      setCheckoutUrl(getCheckoutUrl());
      setTotalPrice(getTotalPrice());
    });
    return unsubscribe;
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-76">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-0 right-0 z-50 px-3 md:px-4" style={{
      background: 'linear-gradient(to top, rgba(245,237,228,1) 60%, rgba(245,237,228,0))'
    }} data-id="element-77">
          <div className="max-w-lg mx-auto" data-id="element-78">
            <button onClick={() => {
          const bumps = getBumps();
          if (!bumps.bump1 && !bumps.bump2) {
            setPopupOpen(true);
          } else {
            trackAddToCart({
              value: totalPrice,
              currency: 'USD'
            });
            window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
          }
        }} className="w-full flex items-center justify-center font-bold md:text-base py-4 px-6 rounded-full transition-all duration-300 whitespace-nowrap no-underline text-[15px] gap-[8px] pl-[24px] pr-[24px]" style={{
          backgroundColor: '#e76f51',
          color: '#ffffff',
          boxShadow: '0 4px 20px rgba(231,111,81,0.4)'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#f08565';
          e.currentTarget.style.transform = 'scale(1.02)';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#e76f51';
          e.currentTarget.style.transform = 'scale(1)';
        }} data-id="element-79">
              Sí, quiero dominar el Método — ${totalPrice.toFixed(2)} USD
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}